import { DefaultValues } from 'react-hook-form'
import { InferType, mixed, object } from 'yup'

import { requiredMessage } from 'directFlow/state/config/content'

import { UsageType } from 'types'

export const usagePageDefaultValues = {
  usageType: undefined,
} satisfies DefaultValues<UsageSchemaType>

export const usagePageSchema = object({
  usageType: mixed<UsageType>().oneOf(Object.values(UsageType)).required(requiredMessage),
})

export type UsageSchemaType = InferType<typeof usagePageSchema>
